import axios from "axios";
import Cookies from "js-cookie";

const baseURL = process.env.REACT_APP_BASE_URL;
const normalizedBaseURL = baseURL?.endsWith('/') ? baseURL : `${baseURL}/`;

let isRefreshing = false;
let refreshPromise = null;

/**
 * Shared refresh manager - ensures only ONE refresh call happens at a time
 * across all API systems (axios instances, RTK Query, etc.)
 */
export const refreshManager = {
  /**
   * Attempt to refresh the token. If a refresh is already in progress,
   * returns the existing promise instead of making a new request.
   */
  async refresh() {
    // If already refreshing, return the existing promise
    if (isRefreshing && refreshPromise) {
      return refreshPromise;
    }

    isRefreshing = true;

    refreshPromise = (async () => {
      try {
        const csrfToken = Cookies.get("__Secure-CSRF-Token") || Cookies.get("CSRF-Token");

        const response = await axios.post(
          `${normalizedBaseURL}api/user/refresh`,
          {},
          {
            withCredentials: true,
            headers: csrfToken ? { 'X-CSRF-Token': csrfToken } : {}
          }
        );

        const newToken = response.data.token;
        sessionStorage.setItem('x-auth', newToken);

        return newToken;
      } finally {
        isRefreshing = false;
        refreshPromise = null;
      }
    })();

    return refreshPromise;
  },

  isRefreshing() {
    return isRefreshing;
  }
};
